import React from 'react';
import { useTemplateTextByCodeAndBusinessUnitWithLocaleQuery } from '@isyc-react/oc-api';
import { ObjectTypeId } from '@isyc-react/types';
import { Spinner } from '@isyc-react/design/bootstrap';
import { TextComponent } from 'common-app/override/oncustomer';
import { DossierStep, useDossierContext, useDossierUpdateOrchestration } from 'common-app/dossier';
export const DossierTextContainer = () => {
    const { dossier } = useDossierContext();
    const [updateStep, { loading }] = useDossierUpdateOrchestration();
    const { data, loading: loadingTemplateText } = useTemplateTextByCodeAndBusinessUnitWithLocaleQuery({
        variables: {
            businessUnit: 'SHARE',
            objectTypeId: ObjectTypeId.DOSSIER,
            code: 'EXPLICATION', //TODO: Falta por determinar el codigo de la plantilla
        },
    });
    const templateText = React.useMemo(() => {
        if (data && data.templateText_read_byCodeAndBusinessUnitWithLocale) {
            return data.templateText_read_byCodeAndBusinessUnitWithLocale;
        }
    }, [data]);
    if (loading || loadingTemplateText || !templateText) {
        return (React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
            React.createElement(Spinner, null)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(TextComponent, { html: templateText.editorHTML, text: templateText.template }),
        React.createElement("div", { className: 'd-flex align-items-center justify-content-between mt-4 flex-column-reverse flex-sm-row gap-3 buttons mb-3' },
            React.createElement("button", { onClick: () => updateStep({ variables: { dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id, step: DossierStep.SUMMARY } }), type: 'button', className: 'btn btn-link btn-lg', disabled: loading },
                React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                    loading ? (React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                        React.createElement(Spinner, { animation: 'border', className: 'text-dark-primary', size: 'sm' }))) : (React.createElement("i", { className: 'text-dark-primary mdi mdi-chevron-left' })),
                    React.createElement("div", { className: 'ms-3' }, "Retour"))),
            React.createElement("button", { type: 'button', className: 'btn btn-secondary btn-lg fw-500', disabled: loading, onClick: () => updateStep({ variables: { dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id, step: DossierStep.DOCUMENTS } }) },
                React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                    React.createElement("div", { className: 'me-3' }, "Passer \u00E0 l\u2019\u00E9tape suivante"),
                    loading ? (React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                        React.createElement(Spinner, { animation: 'border', className: 'text-light', size: 'sm' }))) : (React.createElement("i", { className: 'text-light mdi mdi-check' })))))));
};
